import * as React from "react";
const SvgFiRrCommentDots = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comment-dots_svg__a)">
      <path
        fill="#062147"
        d="M13.5 12a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001 0m3.5-1.5a1.5 1.5 0 1 0 .001 3 1.5 1.5 0 0 0-.001-3m-10 0a1.5 1.5 0 1 0 .001 3 1.5 1.5 0 0 0-.001-3m17 1.84V19c0 2.757-2.243 5-5 5h-5.917C6.082 24 .47 19.208.03 12.854A12.02 12.02 0 0 1 3.509 3.52 12.03 12.03 0 0 1 12.836.029C19.096.454 24 5.86 24 12.339m-2 0c0-5.431-4.084-9.962-9.299-10.316a10.015 10.015 0 0 0-7.777 2.91 10.02 10.02 0 0 0-2.899 7.782C2.398 18.096 7.049 22 13.084 22h5.917c1.654 0 3-1.346 3-3v-6.66z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comment-dots_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentDots;
